
import React, { memo, useState, useEffect, useContext, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import Select, { createFilter } from "react-select";
import moment from 'moment';
import DatePicker from "react-datepicker";
// import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../../../../../BaseUrl";
import axios from "axios";
import {
  _t,
  getCookie,
  getCustomerRegInfo,
  getSystemSettings,
  isValidPkMobile,
} from "../../../../../../functions/Functions";
import MultiAddress from "./MultiAddress";
import { UserContext } from "../../../../../../contexts/User";
import { SettingsContext } from "../../../../../../contexts/Settings";
import ConfirmModal from "./ConfirmModal";
import { useOptimizedSelect } from "../../../../../../hooks/useDebounceCustomer";

const gender = [
  {id:"1",name:"Male"},
  {id:"2",name:"Female"},
  {id:"3",name:"Other"},
]

const CustomerModal = ({
  showSettle,
  modal9Show,
  setModal9Show,
  setOrderDetails,
  orderDetails,
  selectedParty,
  checkDelivery,
}) => {

  const { authUserInfo } = useContext(UserContext);
  const { generalSettings } = useContext(SettingsContext);
 
  const [customer, setCustomer] = useState({
    id:null,
    name:"",
    email:"",
    phn_no:"",
    address:"",
    ref_no:"",
    alt_phn_no: "",
    ntn_no: "",
    gender: "",
    dob: null,
    nearest_landmark: "",
    isRegistered: false
  });
  
  // muti address
  const [addressList, setAddressList] = useState([]);
  const [showCustomer,setShowCustomer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const { order_id } = useParams();
  //const [filterCustomer,setFilterCustomer] = useState([])

  useEffect(()=>{
    if (!modal9Show) return;
    const genderSelect = orderDetails.newCustomerInfo.gender ? gender.find((item)=> item.name === orderDetails.newCustomerInfo.gender) : "";
    setCustomer({
      id: orderDetails.newCustomerInfo?.id,
      name: orderDetails.newCustomerInfo?.name,
      phn_no: orderDetails.newCustomerInfo?.phn_no,
      email: orderDetails.newCustomerInfo?.email,
      address: orderDetails.newCustomerInfo?.address,
      ref_no: orderDetails.newCustomerInfo?.ref_no,
      alt_phn_no: orderDetails.newCustomerInfo?.alt_phn_no,
      ntn_no: orderDetails.newCustomerInfo.ntn_no,
      nearest_landmark: orderDetails.newCustomerInfo.nearest_landmark,
      gender: genderSelect,
      dob: orderDetails.newCustomerInfo.dob ? new Date(orderDetails.newCustomerInfo.dob) : null,
      isRegistered: false
    });
    if(!orderDetails.newCustomerInfo?.name && !orderDetails.newCustomerInfo.phn_no) {
      setAddressList([]);
    }
  },[modal9Show]);

  //customer register
  const handleCustomerRegister = async(e) => {
    e.preventDefault();
    if(!customer.name){
      toast.error("Please enter name");
      return false
    }else if (!customer.phn_no) {
      toast.error("Please enter phone number");
      return false
    }else if (!isValidPkMobile(customer.phn_no)) {
      // toast.error("Please enter valid phone no (03XXXXXXXXX)");
      return false
    }else if(!customer.gender){
      toast.error("Please select gender");
      return false
    }else if(!customer.dob){
      toast.error("Please select date of birth");
      return false
    }

    const params = {
      phn_no: customer.phn_no,
      branch: orderDetails.branch,
      dob: moment(customer.dob).format("YYYY-MM-DD"),
      gender: customer.gender?.name,
      address: customer.address,
      name: customer.name,
      email: customer.email,
    }

    const res = await getCustomerRegInfo(params,setLoading);
    if(res?.returnvalue === 0 && res?.success){
      handleCustomer(e);
      if(res.utype === 2){
        const genderSelect = res.gender ? gender.find((item)=> item.name === res.gender) : customer.gender;
        const date = res.dob_year ? new Date(Number(res.dob_year) + "-" + Number(res.dob_month) + "-" + Number(res.dob_day)) : customer.dob;
        setCustomer((curr) => ({
          ...curr,
          name: res.cust_name,
          email: res.cust_email,
          phn_no: res.pos_cust_phone,
          gender: genderSelect,
          dob: date,
        }))
      }
    }
  }

  // submit customer info
  const handleCustomer = async(e) => {
    e.preventDefault();
    setLoading(true)
    const customerValidation =  order_id || (customer.ref_no?.length !== undefined &&
    customer.ref_no?.length !== 0 && customer.ref_no?.length  >= selectedParty.ref_min &&
    customer.ref_no?.length <= selectedParty.ref_max);
    const checkCustomer = customer.name !== "" && customer.phn_no !== "";

    if (parseInt(getSystemSettings(generalSettings, "customer_number_validation")) === 1 && customer.phn_no) {
      if(!isValidPkMobile(customer.phn_no)){
        // toast.error("Please enter valid phone no (03XXXXXXXXX)");
        setLoading(false);
        return false;
      }
    }
    
    const customerInfo = {
      ...orderDetails.newCustomerInfo,
      id: customer.id || null,
      name: customer.name || "",
      email: customer.email || "",
      phn_no: customer.phn_no || "",
      address: customer.address || "",
      alt_phn_no: customer?.alt_phn_no || "",
      ref_no: customer.ref_no || "",
      ntn_no:  customer.ntn_no || "",
      nearest_landmark:  customer.nearest_landmark || "",
      gender: customer.gender?.name || "",
      dob: customer.dob ? moment(customer.dob).format("YYYY-MM-DD") : "",
      is_confirm: true,
    };

    const setCustomerInfo = {
      ...orderDetails,
      newCustomerInfo: customerInfo,
    }

    const updateCustomerInfo = () => {
      setOrderDetails(setCustomerInfo);
      setModal9Show(false);
    };

    const customerNotConfirm = () => {
      setOrderDetails((curr)=>({
        ...curr,
        newCustomerInfo:{
          ...setCustomerInfo.newCustomerInfo,
          is_confirm: false,
        }
      }));
    }

    const updateCustomerFoodPanda = (dupRef = "") =>{
      if(dupRef === "exist"){
        customerNotConfirm();
        toast.error("Ref no is already exist!");
      }else{
        setModal9Show(false);
        setOrderDetails(setCustomerInfo);
      }
    }

    if (
      selectedParty && parseInt(selectedParty.show_ref_no) === 1 &&
      (selectedParty.name.match(/food(.*)panda/i))
    ) {
      if (customer.name !== "" && customerValidation) {
        //duplicate ref no api
        const refUrl = BASE_URL + "/settings/check-duplicate-ref-no/" + customer.ref_no;
        await axios
        .get(refUrl, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          updateCustomerFoodPanda(res.data);
        })
        .catch((err)=> updateCustomerFoodPanda());
       
      } else {
        customerNotConfirm();
        toast.error(`Please fill ${customer.name == "" ? customer.name : ""} ${!customerValidation ? "ref no between " + selectedParty.ref_min + "-" +selectedParty.ref_max + " digits." : ""}`);
      }
    }else if(selectedParty && parseInt(selectedParty.show_ref_no) === 1 && checkDelivery && !customerValidation && !checkCustomer){
      customerNotConfirm();
      toast.error(`Please fill customer ${customer.name == "" ? "name" : ""} ${ customer.name == "" && customer.phn_no == "" ? "&" : ""} ${customer.phn_no == "" ? "phone number" : ""} ${!customerValidation ? " ref no between " + selectedParty.ref_min + "-" + selectedParty.ref_max + " digits." : ""}`);
    }else if(selectedParty && parseInt(selectedParty.show_ref_no) === 1 && !customerValidation){
      customerNotConfirm();
      toast.error(`Please fill ref no between ${selectedParty.ref_min}-${selectedParty.ref_max} digits.`);
    }else if(checkDelivery && !checkCustomer){
      toast.error(`Please fill customer ${customer.name == "" ? "name" : ""} ${ customer.name == "" && customer.phn_no == "" ? "&" : ""} ${customer.phn_no == "" ? "phone number" : ""}`);
    }else{
      updateCustomerInfo();
    }
   
    setLoading(false);
  };

  const handleCustomerRemove = ()=>{
    setShow(false);
    setModal9Show(false);
    setShowCustomer(false);
    setCustomer((curr)=>({
      ...curr,
      id: null,
      name: "",
      email: "",
      phn_no: "",
      alt_phn_no: "",
      ntn_no : "",
      gender: "",
      dob: null,
      address: "",
    }));
    setOrderDetails((curr)=>({
      ...curr,
      newCustomerInfo: {
        ...curr.newCustomerInfo,
        id: null,
        name: "",
        email: "",
        phn_no: "",
        order: null,
      }
    }));
  }
  
  //search customer
  const customerSearch = async(customers) => {
    if(!customers){
      return false;
    }
    if(customers?.address_book?.length > 1 ){
      setShowCustomer(true);
      setAddressList(customers.address_book);
    }else{
      setShowCustomer(false);
      setAddressList([]);
    }

    const genderSelect = orderDetails.newCustomerInfo.gender ? gender.find((item)=> item.name === orderDetails.newCustomerInfo.gender) : "";
    setCustomer((curr)=>({
      ...curr,
      id: customers?.id,
      name: customers.name,
      email: customers.email ? customers.email : "",
      phn_no: customers?.phn_no,
      alt_phn_no: customers?.alt_phn_no,
      ntn_no : customers.ntn_no ? customers.ntn_no : "",
      gender: genderSelect,
      dob: customers.dob ? new Date(customers.dob) : null,
      address: customers?.address_book?.length > 1 ? customers.address_book[0].address : (customers?.address ? customers.address : ""),
    }));

    if(customers?.blacklist){
      setShow(true)
    }
    setOrderDetails((curr)=>({
      ...curr,
      newCustomerInfo: {
        ...curr.newCustomerInfo,
        order: customers?.latest_order ? {
          ...customers?.latest_order,
          phn_no: customers?.phn_no,
        } : null,
      }
    }))
    const params = {
      phn_no: customers?.phn_no,
      branch: orderDetails.branch,
    }
    if(generalSettings && getSystemSettings(generalSettings, "loyality_enable") === "techmixers"){
      const res = await getCustomerRegInfo(params,setLoading);
      if(res?.returnvalue != 27 && res?.returnvalue != 16 && res?.success === true && res?.pos_cust_phone){
        toast.success("Customer Already Registered");
        setCustomer((curr)=>({
          ...curr,
          isRegistered:true
        }))
        return false
      }
    }
  };
  
  //handle on change input
  const handleChangeInput = (e) =>{
    const {name, value} = e.target;
    setCustomer((curr)=>({
      ...curr,
      [name]: value,
    }))
  }

  //handle on change select
  const handleChangeSelect = (name, value) =>{
    setCustomer((curr)=>({
      ...curr,
      [name]: value,
    }))
  }

  //Debounce logic and searched customer
  const {
    inputValue,
    onInputChange,
    options: searchedCustomer,
    isLoading: loader,
    noOptionMessage,
  } = useOptimizedSelect("/settings/get-all-customer", {
    onEmptyResponse: (val) => {
      setCustomer((curr) => ({
        ...curr,
        id: null,
        name: "",
        email: "",
        address: "",
        ref_no: "",
        alt_phn_no: "",
        phn_no: val,
        gender: "",
        dob: null,
      }));
    },
    onError: () => {
      if(parseInt(authUserInfo.details?.offline_enable)){
        toast.error("Can't search customer in offline mode",{
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }else{
        toast.error("Please try again",{
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }
  });

  return (
    <>
      <Modal
        show={modal9Show}
        onHide={() => {
          if (!orderDetails?.newCustomerInfo?.phn_no) {
            setOrderDetails((curr) => ({
              ...curr,
              newCustomerInfo: {
                ...curr.newCustomerInfo,
                order: null,
              },
            }));
          }
          setModal9Show(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        zIndex={14999}
      >
        <Modal.Header closeButton className="customer-header">
          <Modal.Title className="customer-title" id="contained-modal-title-vcenter">
            {/* Modal Header */}
            <div className="container-fluid mt-1">
              <h4 className="fw-bold mb-0 input-field" id="exampleModalLabel">
                Search Customer
              </h4>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Modal Body */}
          <div className="modal-body pt-0">
            <div className="container-fluid" style={{ paddingLeft: "0px" }}>
            
              <div className="row">
                <div className="col-6">
                  <label
                    className="col-form-label fw-bold d-flex justify-content-start"
                  >
                    Searched By Phone No
                  </label>
                  <Select
                    isDisabled={selectedParty && selectedParty.name?.match(/food(.*)panda/i)}
                    options={searchedCustomer}
                    components={makeAnimated()}
                    getOptionLabel={(option) => option.name_phone}
                    getOptionValue={(option) => option.id}
                    classNamePrefix="select"
                    className="table-text"                  
                    onChange={customerSearch}
                    onInputChange={onInputChange}                  
                    maxMenuHeight="200px"
                    placeholder="Customer Search"
                    noOptionsMessage={() => {
                      return loader ? 
                      <div className="spinner-border spinner-border-sm" role="status">
                        <span className="sr-only">Loading...</span>
                      </div> : noOptionMessage
                    }}
                    isClearable                  
                  />
                </div>
                {
                  addressList && addressList.length > 0 &&
                  <div className="col-2 d-flex align-items-end mb-1 px-1">
                    <button className="btn btn-sm btn-primary rounded-sm" onClick={()=>setShowCustomer(true)}>Multi Address</button>
                  </div>
                }
                {!showSettle &&
                 orderDetails.newCustomerInfo.order &&
                 <div className="col-2 d-flex align-items-end mb-1 px-2">
                   <button className="btn btn-sm btn-success rounded-sm" onClick={()=>setOrderDetails((curr)=> ({
                      ...curr,
                      newCustomerInfo:{
                        ...curr.newCustomerInfo,
                        modal: !curr.newCustomerInfo.modal
                      }
                    }))}
                  >
                    Last Order
                  </button>
                 </div> 
                }
              </div>
              
              <h4 className="d-flex justify-content-start fw-bold mb-1 mt-3">
                Add Customer
              </h4>
              <form 
              onSubmit={handleCustomer}
              // autoComplete="off"
              >
                <div className="row">
                  <div className="col-4">
                    <label
                      for="recipient-name"
                      className="col-form-label fw-bold d-flex justify-content-start p-0"
                    >
                      Name
                    </label>
                    <input
                      disabled={(selectedParty && selectedParty?.show_ref_no === 1) && (selectedParty.name.match(/food(.*)panda/i))}
                      type="text"
                      className="form-control mb-2 customer-input"
                      id="recipient-name"
                      name="name"
                      placeholder="Name"
                      onChange={handleChangeInput}
                      value={customer.name}
                    />
                  </div>
                  <div className="col-4">
                    <label
                      for="phone"
                      className="col-form-label fw-bold d-flex justify-content-start p-0"
                    >
                      Phone
                    </label>
                    <input
                      //type="number"
                      type="text" 
                      maxLength={15}
                      pattern="^[+]?[0-9\s-]+$"
                      className="form-control customer-input"
                      onKeyDown={(evt) => ["e", "E","ArrowUp","ArrowDown"].includes(evt.key) && evt.preventDefault()}
                      onWheel={(e) => e.target.blur()}  
                      id="phone"
                      name="phn_no"
                      placeholder="03XXXXXXXXX"
                      onFocus={() => {
                        if (!customer.phn_no) {
                          setCustomer((curr) => ({ ...curr, phn_no: "03" }));
                        }
                      }}
                      onChange={(e) => {
                        let phoneNumber = e.target.value;
                        setCustomer((curr)=>({
                          ...curr,
                          phn_no: phoneNumber
                        }));
                      }}
                      value={customer.phn_no}
                    />
                  </div>                
                  <div className="col-4">
                    <label
                      for="alt-phone"
                      className="col-form-label fw-bold d-flex justify-content-start p-0"
                    >
                      Alt Phone
                    </label>
                    <input
                      //type="number"
                      type="text" 
                      maxlength="13" 
                      pattern="^\+?\d{0,9}-?\d{0,9}$"
                      className="form-control customer-input"
                      onKeyDown={(evt) => ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) && evt.preventDefault()}
                      onWheel={(e) => e.target.blur()}  
                      id="alt-phone"
                      name="alt_phn_no"
                      placeholder="0304***"
                      onChange={handleChangeInput}
                      value={customer.alt_phn_no}
                    />
                  </div>
                </div>
                <div className="row">
                
                  <div className="col-6">
                    <label
                      for="email"
                      className="col-form-label fw-bold d-flex justify-content-start p-0"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control customer-input"
                      id="email"
                      placeholder="Email"
                      name="email"
                      onChange={handleChangeInput}
                      value={customer.email || ""}
                    />
                  </div>
                  <div className="col-6">
                    <label
                      for="ref"
                      className="col-form-label fw-bold d-flex justify-content-start p-0"
                    >
                      Ref No
                    </label>
                    <input
                      // disabled={order_id}
                      type="text"
                      className="form-control customer-input"
                      id="recipient-name"
                      placeholder="ref"
                      name="ref_no"
                      onChange={handleChangeInput}
                      value={customer.ref_no}
                      minLength={
                        selectedParty &&
                        selectedParty.show_ref_no === 1 &&
                        selectedParty.ref_min > 0 && selectedParty.ref_min
                      }
                      maxLength={
                        selectedParty &&
                        selectedParty.show_ref_no === 1 &&
                        selectedParty.ref_max > 0 ? selectedParty.ref_max : 20
                      }
                    />
                  </div>
                  {/* address */}
                  <div className="row mt-2 pr-0">
                    <label
                      for="address"
                      className="col-form-label fw-bold d-flex justify-content-start pt-0 pb-0"
                    >
                      Delivery Address
                    </label>
                
                    <div className="col-12 pr-0">
                      <input
                        required={checkDelivery && (selectedParty && !selectedParty.name.match(/food(.*)panda/i))}
                        type="text"
                        className="form-control customer-input"
                        id="address"
                        name="address"
                        placeholder="Address"
                        onChange={handleChangeInput}
                        value={customer.address}
                      />
                    </div>
                  </div>
                </div>

                {/* ntn no */}
                <div className="row mt-2 pr-0">
                  <div className="col-4">
                    <label
                      for="ntn_no"
                      className="col-form-label fw-bold d-flex justify-content-start pt-0 pb-0"
                    >
                      NTN No
                    </label>
                
                    <div className="col-12 pr-0">
                      <input
                        type="text"
                        className="form-control customer-input"
                        id="ntn_no"
                        name="ntn_no"
                        placeholder="ntn no"
                        onChange={handleChangeInput}
                        value={customer.ntn_no}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <label
                      for="dob"
                      className="col-form-label fw-bold d-flex justify-content-start pt-0 pb-0"
                    >
                      Date of Birth
                    </label>
                
                    <div className="col-12 pr-0">
                      <DatePicker
                        selected={customer.dob}
                        onChange={(date) => handleChangeSelect("dob", date)}
                        maxDate={new Date()}
                        isClearable
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control t-mb-15 mb-md-0"
                        placeholderText={"Dob"}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <label
                      for="gender"
                      className="col-form-label fw-bold d-flex justify-content-start pt-0 pb-0"
                    >
                      Gender
                    </label>
                
                    <div className="col-12 pr-0">
                      <Select
                        menuPlacement="top"
                        options={gender ? gender : []}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        value={customer.gender}
                        isClearable
                        classNamePrefix="select"
                        className="table-text"
                        onChange={(gender)=>handleChangeSelect("gender",gender)}                                
                        maxMenuHeight="200px"
                        placeholder={"Select gender" + ".."}
                      />
                    </div>
                  </div>
                </div>
                <Modal.Footer
                  style={{
                    borderTop: "none",
                    justifyContent: "space-between",
                    display: "block",
                    marginBottom:"-15px",
                    paddingRight:"0"
                  }}
                >
                  {/* Modal Footer */}
                  <div className="modal-footer" style={{ borderTop: "none",paddingBottom:"0",paddingRight:"0" }}>
                    <div className="container-fluid " style={{ padding: "0px" }}>
                      <div className="row d-flex justify-content-end">
                        {
                          loading && (
                            <div className="spinner-border text-primary mt-1" role="status">
                              <span className="sr-only">Loading...</span>
                            </div>
                          )
                        }
                        {
                          generalSettings && getSystemSettings(generalSettings, "loyality_enable") === "techmixers" && !customer.isRegistered &&
                          <div className="col-3 mb-1">
                            <button disabled={loading} className="btn w-100 fw-bold rounded-25 btn-secondary" onClick={(e)=>handleCustomerRegister(e)}>Register</button>
                          </div>
                        }
                        <div className="col-3 mb-1">
                          <button
                            type="submit"
                            className="btn btn-primary w-100 fw-bold rounded-25"                            
                          >
                            CONFIRM
                          </button>
                        </div>
                        {
                          /*
                        <div className="col-sm-3 mb-1">
                          <button
                            type="button"
                            className="btn w-100 fw-bold rounded-25"
                            style={{
                              backgroundColor: "#939393",
                              color: "#fff",
                              borderRadius: "0.5rem",
                            }}
                            onClick={() => setModal9Show(false)}
                          >
                            CANCEL
                          </button>
                        </div>
                          */}
                      </div>
                    </div>
                  </div>
                </Modal.Footer>
              </form>
            </div>
          </div>
        </Modal.Body>
      
      </Modal>
      {/*multi address Modal*/}
      <MultiAddress
        showCustomer={showCustomer}
        setShowCustomer={setShowCustomer}
        addressList={addressList}
        handleChangeInput={handleChangeInput}
      />
      <ConfirmModal
        open={show}
        title="Blacklist Customer"
        message="Do you want to proceed with this order?"
        onYes={() => {
          setShow(false);
        }}
        onNo={() => handleCustomerRemove()}
      />
    </>
  );
};

export default memo(CustomerModal);
